var memberInfoCookieName='hg546jhgfv';
function saveMemberInfoFromQueryString(queryString){
	var params = queryString.split('&');
	var member = {};
	for(var i=0;i<params.length;i++){
		var param = params[i];
		var keyValue = param.split('=');
		var key = decodeURIComponent(keyValue[0]);
		var value = decodeURIComponent(keyValue[1]);
		member[key]=value;
	}
	saveMemberInfo(member);
}
$(function(){ //NOTE: quick cookie check.
	var member = fetchMemberInfo();
	if(member !== null && typeof member !== 'undefined'){
		if(typeof member.version !== 'undefined' && member.version >= cookieVersionNumber){
			if($('select[name="country"]').length){
				//make sure we reload the address fields if the country is not the "US"
				if(member !== null && (typeof fillInDonationFormInfo !== 'undefined' || $('select[name="country"]').length)){
					if(typeof member.country !== 'undefined' && member.country !== null && typeof sharedFunctions.addressFieldsByCountryCode[member.country] !== 'undefined'){
						$('select[name="country"]').val(member.country);
						$('select[name="country"]').change();
					}else{
						$('select[name="country"]').val("US");
						$('select[name="country"]').change();
					}
				}
				memberInfoFillForm();
			}else{
				delayedMemberInfoFill();
			}
		}else{
			hideStoredTokenForm();
			$.ajax({
				type: "GET",
				url: "/logout",
				data: {},
				success: function(data){
					if(data.success){
						$('#memberName #nameSpan').text('');
						progressTiles(false);
						verified(false);
						clearProfileInfo();
					}
				},
				dataType: "json"
			});
		}
	}
})
function translateKimbiaToInternal(kimbiaKey){
	var translator=[
		{k:'FirstName',i:'firstName'},
		{k:'LastName',i:'lastName'},
		{k:'ContactEmail',i:'email'},
		{k:'Mailing Address|country',i:'country'},
		{k:'MailingAddress|street1',i:'street1'},
		{k:'MailingAddress|street2',i:'street2'},
		{k:'MailingAddress|city',i:'city'},
		{k:'Mailing Address|state',i:'state'},
		{k:'MailingAddress|zipcode',i:'zip'}
	];
	for(var i=0;i<translator.length;i++){
		if(kimbiaKey==translator[i].k){
			return translator[i].i;
			break;
		}
	}
	return kimbiaKey; //NOTE: fallback for keys that couldn't be found.
}
function saveMemberInfoFromForm(form){
	form = $(form);
	if(form.is('form')){
		var data = $(form).serialize();
		saveMemberInfoFromQueryString(data);
	}else{
		var data={};
		form.find("input, select").each(function(i){
			data[translateKimbiaToInternal($(this).attr('name'))]=$(this).val();
		});
		saveMemberInfo(data);
	}
}
function saveMemberInfo(memberData){
	var newMemberData = {}
	var whiteList = ['firstName','lastName','zip','email','street1','street2','city','country','state','lookForUpdatesAfter','source','entryTopic','phone1','phone2','verifiedEmailSent'];
	for(var key in memberData){
		if($.inArray(key,whiteList)!=-1)
			newMemberData[key]=memberData[key];
	}
	var currentMemberData = fetchMemberInfo();
	var needsUpdate = true;
	if(currentMemberData!==null){
		needsUpdate = updateMember(newMemberData,currentMemberData);
	}else{
		currentMemberData=newMemberData;
		currentMemberData.version = cookieVersionNumber;  //Add the cookie version number if the cookie doesn't exist
		needsUpdate=true;
	}
	if(needsUpdate){
		currentMemberData.updated=true;
		cookies.setItem(memberInfoCookieName, Base64.encode(JSON.stringify(currentMemberData)), Infinity, '/', null, true, "Strict", false);
	}
	return needsUpdate;
}
function fetchMemberInfo(){
	var data = cookies.getItem(memberInfoCookieName);
	if(data!==""){
		try{
			data = Base64.decode(data);
		}catch(ex){
			//do nothing, just roll into finally block.
		}finally{
			data = JSON.parse(data);
		}
	}
	return data;
}
function updateMember(newMemberData,currentMemberData){
	//NOTE: returns true if the object has been updated.
	var needsUpdate=false;
	for(var key in newMemberData){
		if(typeof currentMemberData[key] == 'undefined' || currentMemberData[key] != newMemberData[key])
			needsUpdate=true;
		currentMemberData[key] = newMemberData[key];
	}
	return needsUpdate;
}
function login(data,callback){
	loginWithOptions(data,{},callback);
}
function loginWithOptions(data,options,callback){
	var silent=false;
	if(typeof options.silent !== "undefined"){
		silent=options.silent;
		delete options.silent;
	}
	
	options.type="POST";
	options.url="/gh3j456";
	options.data=data;
	options.success = function(data){
		if(data.success){
			var member = fetchMemberInfo();
			var status = sharedFunctions.addressCompleted(member);
			if(status == 'empty'){
				progressTiles(true, false);
			}else if(status == 'partial'){
				progressTiles(true, true);
			}else{
				verified(true);
			}
			callback(member);
		}else{
			if(!silent){
				if(typeof data.errors!=='undefined' && typeof data.errors[0] !== 'undefined')
					errorDisplayAndTrack(data.errors[0]);
				else
					errorDisplayAndTrack("An error occured while registering or logging in. Please refresh the page and try again.");
			}
			callback(null);
		}
	}
	options.dataType="json";

	$.ajax(options);
}
function lookForMemberInfoUpdatesAfter(date){
	var member = fetchMemberInfo();
	member.lookForUpdatesAfter=date;
	saveMemberInfo(member);
}
$(function(){
	var member = fetchMemberInfo();
	if(typeof member !== "undefined" && member !== null && typeof member.lookForUpdatesAfter !== "undefined" && member.lookForUpdatesAfter !== null){
		var now = new Date();
		if(Date.parse(member.lookForUpdatesAfter)<now){
			$.ajax({
				type: "POST",
				url: "/hg6jcvbm",
				data: member,
				success: function(data){
					//TODO: do something. the cookie is already being set though.
				},
				dataType: "json"
			});
		}
	}
})
$(".login").click(function(e){
	e.preventDefault();
	var data = {};
	$(this).parents(".modal").find('input').each(function(){
		var name = $(this).attr('name');
		data[name] = $(this).val();
	})
	login(data,function(member){
		if(member===null) return;
		$('body').trigger('loggedIn',member);
	});
});
$('body').on('loggedIn',function(e,member){
	$('#memberName #nameSpan').text(member.firstName);
	$('#memberName').removeClass('hidden')
	var status = sharedFunctions.addressCompleted(member);
	if(status == 'empty'){
		progressTiles(true, false);
	}else if(status == 'partial'){
		progressTiles(true, true);
	}else{
		verified(true);
	}
	$('#loginModal').modal('hide');
	$('#registerModal').modal('hide');
	var currentForm = $(".forms.current");
	if(member !== null && (typeof fillInDonationFormInfo !== 'undefined' || $('select[name="country"]').length)){
		if(typeof member.country !== 'undefined' && member.country !== null && typeof sharedFunctions.addressFieldsByCountryCode[member.country] !== 'undefined'){
			$('select[name="country"]').val(member.country);
			$('select[name="country"]').change();
		}else{
			$('select[name="country"]').val('US');
			$('select[name="country"]').change();
		}
	}
	if(typeof fillInMemberInfo !== 'undefined')
		fillInMemberInfo(currentForm);
	else
		altFillInMemberInfo(currentForm);
	if(typeof member.storedToken != "undefined"){
		displayStoredTokenForm();
	}
	toggleLoginButtons();
	fillProfileInfo();
});
$("#logout").click(function(e){
	e.preventDefault();
	hideStoredTokenForm();
	$.ajax({
		type: "GET",
		url: "/logout",
		data: {},
		success: function(data){
			if(data.success){
				$('body').trigger('loggedOut');
			}
		},
		dataType: "json"
	});
})
$('body').on('loggedOut',function(e){
	$('#memberName #nameSpan').text('');
	toggleLoginButtons();
	progressTiles(false);
	verified(false);
	clearProfileInfo();
})
$("#resetPassword").click(function(e){
	e.preventDefault();
	var data = {};
	$(this).parents("#loginModal").find('input').each(function(){
		var name = $(this).attr('name');
		data[name] = $(this).val();
	})
	if(typeof data["email"] === "undefined" || data["email"] == null || data["email"] == ""){
		errorDisplayAndTrack("Please enter your email address.");
		return;
	}
	$.ajax({
		type: "POST",
		url: "/generate-reset",
		data: data,
		success: function(data){
			successDisplay("Success!","An email has been sent to help you reset your password.");
			$('#loginModal').modal('hide');
		},
		dataType: "json"
	});
});
var memberInfoFillAttempts=0;
var maxMemberInfoFillAttempts=5;
function delayedMemberInfoFill(){
	memberInfoFillAttempts++;
	if($('.kimbiaDonationForm div.password').length==0){
		if(memberInfoFillAttempts>maxMemberInfoFillAttempts){
			memberInfoFillForm();
		}
		else{
			setTimeout("delayedMemberInfoFill()",100*memberInfoFillAttempts);
		}
	}else{
		memberInfoFillForm();
	}
}
function memberInfoFillForm(){
	var member = fetchMemberInfo();
	if(member != null && typeof member.firstName !== "undefined"){
		if(typeof member.sessionKey !== "undefined"){
			toggleLoginButtons();
			fillProfileInfo();
			$('#memberName #nameSpan').text(member.firstName);
			$('#memberName').removeClass('hidden')
			var status = sharedFunctions.addressCompleted(member);
			if(status == 'empty'){
				progressTiles(true, false);
			}else if(status == 'partial'){
				progressTiles(true, true);
			}else{
				verified(true);
			}
		}
		var currentForm = $(".forms.current");
		if(typeof fillInMemberInfo !== 'undefined')
			fillInMemberInfo(currentForm);
		else
			altFillInMemberInfo(currentForm);
	}
}
function toggleLoginButtons(){
	$("#openLogin").toggle();
	$("#logout").toggle();
	$('#register').toggle();
	$('.widgetLogin').toggle();
	$('#Password').toggle();
	$('.registerDisplay').toggle();
	$('.loginDisplay').toggle();
}

var Base64 = {
 
	// private property
	_keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
 
	// public method for encoding
	encode : function (input) {
		var output = "";
		var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
		var i = 0;
 
		input = Base64._utf8_encode(input);
 
		while (i < input.length) {
 
			chr1 = input.charCodeAt(i++);
			chr2 = input.charCodeAt(i++);
			chr3 = input.charCodeAt(i++);
 
			enc1 = chr1 >> 2;
			enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
			enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
			enc4 = chr3 & 63;
 
			if (isNaN(chr2)) {
				enc3 = enc4 = 64;
			} else if (isNaN(chr3)) {
				enc4 = 64;
			}
 
			output = output +
			this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
			this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
 
		}
 
		return output;
	},
 
	// public method for decoding
	decode : function (input) {
		var output = "";
		var chr1, chr2, chr3;
		var enc1, enc2, enc3, enc4;
		var i = 0;
 
		input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
 
		while (i < input.length) {
 
			enc1 = this._keyStr.indexOf(input.charAt(i++));
			enc2 = this._keyStr.indexOf(input.charAt(i++));
			enc3 = this._keyStr.indexOf(input.charAt(i++));
			enc4 = this._keyStr.indexOf(input.charAt(i++));
 
			chr1 = (enc1 << 2) | (enc2 >> 4);
			chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
			chr3 = ((enc3 & 3) << 6) | enc4;
 
			output = output + String.fromCharCode(chr1);
 
			if (enc3 != 64) {
				output = output + String.fromCharCode(chr2);
			}
			if (enc4 != 64) {
				output = output + String.fromCharCode(chr3);
			}
 
		}
 
		output = Base64._utf8_decode(output);
 
		return output;
 
	},
 
	// private method for UTF-8 encoding
	_utf8_encode : function (string) {
		string = string.replace(/\r\n/g,"\n");
		var utftext = "";
 
		for (var n = 0; n < string.length; n++) {
 
			var c = string.charCodeAt(n);
 
			if (c < 128) {
				utftext += String.fromCharCode(c);
			}
			else if((c > 127) && (c < 2048)) {
				utftext += String.fromCharCode((c >> 6) | 192);
				utftext += String.fromCharCode((c & 63) | 128);
			}
			else {
				utftext += String.fromCharCode((c >> 12) | 224);
				utftext += String.fromCharCode(((c >> 6) & 63) | 128);
				utftext += String.fromCharCode((c & 63) | 128);
			}
 
		}
 
		return utftext;
	},
 
	// private method for UTF-8 decoding
	_utf8_decode : function (utftext) {
		var string = "";
		var i = 0;
		var c = c1 = c2 = 0;
 
		while ( i < utftext.length ) {
 
			c = utftext.charCodeAt(i);
 
			if (c < 128) {
				string += String.fromCharCode(c);
				i++;
			}
			else if((c > 191) && (c < 224)) {
				c2 = utftext.charCodeAt(i+1);
				string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
				i += 2;
			}
			else {
				c2 = utftext.charCodeAt(i+1);
				c3 = utftext.charCodeAt(i+2);
				string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
				i += 3;
			}
 
		}
 
		return string;
	}
 
}